<template>
  <div class="grid-table-row overflow-hidden grid-table-row-dark py-0" :class="{'highlighted':highlighted}">
    <div class="item__dateTime">
      <span>{{ item.startTs | formatDate }}</span><br>
      <span class="text-small">{{ item.startTs | formatTime }}</span>
    </div>
    <div class="item__location">
      <div class="text-small">
        {{ item.reversedGeolocation !== true ? item.reversedGeolocation : '' }}
        {{ item.municipality }}
        {{ item.subRegion }}
        {{ item.region }}
        {{ item.country }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    highlighted: {
      type: Boolean
    }
  }
}
</script>
